import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  height: '100%',
  gap: (p) => p.spacing(0.5),
};
